module.exports = __webpack_public_path__ + "img/compliance-default.39a08c08.webp";